import request from '../../../utils/request';
import {paramSecret} from "../../../utils/commonSecret";

// 账号注销
export async function AccountCancel(params) {
    return request('/api/v1/business-server/member/accountCancel', {
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(paramSecret(params)),
    })
}

// 移动端APP渠道账号注销
export async function AccountCancelForChannelApp(params) {
    return request('/api/v1/business-server/member/accountCancelForChannelApp', {
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(paramSecret(params)),
    })
}

// 移动端APP账号注销撤回
export async function AccountCancelRepealForApp(params) {
    return request('/api/v1/business-server/member/accountCancelRepealForApp', {
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(paramSecret(params)),
    })
}


// 未登录状态注销撤回
export async function accountCancelRepealWithGameId(params) {
    return request('/api/v1/business-server/member/accountCancelRepealWithGameId', {
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(paramSecret(params)),
    })
}

// 获取用户信息
export async function getUserInfo(params) {
    return request('/api/v1/user/userinfo',{
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(paramSecret(params)),
    })
}

// 获取用户信息
export async function getUserInfoClear(params) {
    return request('/api/v1/user/userinfo-clearv2',{
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(paramSecret(params)),
    })
}




// 发送短信验证码 token版
export async function sendSmsCodeByToken(params) {
    return request('/api/v1/business-server/member/sendsmscodesliderbytoken',{
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(paramSecret(params)),
    })
}



// 查询绑定信息
export async function bindPhoneQuery(params) {
    return request('/api/v1/business-server/member/kefu/bindPhoneQuery',{
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(paramSecret(params)),
    })
}

// 换绑手机
export async function changePhone(params) {
    return request('/api/v1/business-server/member/kefu/changePhone',{
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(paramSecret(params)),
    })
}
// 绑定手机
export async function bindPhone(params) {
    return request('/api/v1/business-server/member/kefu/bindPhone',{
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(paramSecret(params)),
    })
}

// 绑定手机
export async function unBindPhone(params) {
    return request('/api/v1/business-server/member/kefu/unBindPhone',{
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(paramSecret(params)),
    })
}


